import React, { FunctionComponent } from 'react';
import styles from './static-page-jumbotron.module.scss';
import headerBottomIcon from '../../assets/images/static-jumbotron-icons.svg';
import AnchorLink from 'react-anchor-link-smooth-scroll';

export interface IStaticPageJumbotronProps {
  headerIcon: {
    url: string;
    description: string;
  };
  headerBold: string;
  headerLight: string;
  description: string;
  buttonText: string;
}

export const StaticPageJumbotron: FunctionComponent<IStaticPageJumbotronProps> = ({
  headerIcon,
  headerBold,
  headerLight,
  description,
  buttonText
}) => {
  return (
    <section className={styles.wrapper}>
      <div
        className={styles.header}
        style={{ backgroundImage: `url(${headerIcon.url})` }}
      >
        <h1 className={styles.headerText}>
          <strong>{headerBold}</strong>
          <br />
          {headerLight}
        </h1>
        <p className={styles.description}>{description}</p>
      </div>
      <div className={styles.headerBottom}>
        <div className={styles.readMoreWrapper}>
          <AnchorLink
            offset="100"
            className={styles.readMore}
            href="#read-more"
          >
            <span className={styles.readMoreText}>{buttonText}</span>
          </AnchorLink>
        </div>
        <img src={headerBottomIcon} alt="people" />
      </div>
    </section>
  );
};
